<template>
    <!--<q-card class="q-mt-sm q-mb-sm q-pa-sm wrapper" :style="style">-->
        <div v-html="localModel.text" :style="style"></div>
    <!--</q-card>-->
</template>

<script>
    import QCard from 'quasar-framework/src/components/card/QCard'
    export default {
        name: 'TextViewer',
        components: {QCard},
        props: ['model', 'draggable', 'inline', 'maxHeight'],
        methods: {
            ondragstart (e) {
                e.dataTransfer.effectAllowed = 'copy'
                e.dataTransfer.setData('text', JSON.stringify(this.localModel))
            },
        },
        computed: {
            fullModel () {
                return this.$store.getters.pictures.find(p => p.id === this.localModel.id)
            },
            style () {
                let s = ''
                if (this.inline) {
                    s += 'display: inline-block; '
                }

                if (this.maxHeight) {
                    s += `height: ${this.maxHeight}px; overflow: auto; `
                }

                return s
            }
        },
        mounted () {
            this.localModel = this.model
        },
        watch: {
            model (current) {
                this.localModel = current
            },
            fullModel () {
                this.localModel = this.fullModel
            },
        },
        data () {
            return {
                localModel: {},
            }
        },
    }
</script>

<style scoped lang="scss">
    .wrapper {
        //border: 1px dashed gray;
        width: 250px;
    }
</style>